import AppRoutes from './routes'   // custom routing terpisah
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/Footer'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import './App.css'

function AppWrapper() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  )
}

function App() {
  return (
    <>
      <Navbar />
      <AppRoutes />
      <Footer />
    </>
  )
}

export default AppWrapper;
